import React from 'react'
import { showLogin } from '@core/Areas/Login/helpers/showLogin'
import { useLogon } from '@core/Utils/hooks/useLogon'
import { AuthenticatedAccountContext } from './context'

export const RequireAuth: React.FC<React.PropsWithChildren> = ({ children }) => {
  const accountState = useLogon()

  React.useEffect(() => {
    if (accountState?.isLoggedIn === false) {
      showLogin({ onLoginCancelledRedirectUrl: '/' })
    }
  }, [accountState])

  if (!accountState || !accountState.isLoggedIn || accountState.accountNumber === null) {
    return null
  }

  const { accountNumber } = accountState

  return (
    <AuthenticatedAccountContext.Provider value={{ accountNumber }}>
      {children}
    </AuthenticatedAccountContext.Provider>
  )
}
